import SideMenu from '@/containers/side-menu/SideMenu.vue'
import OutdatedRegister from '@/pages/outdated-register/OutdatedRegister'

export default {
  path: '/outdated-register',
  name: 'OutdatedRegister',
  components: {
    mainContent: OutdatedRegister,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'retroactive-credit'
    },
    breadcrumb: {
      title: 'Registro Retroativo',
      paths: [
        { title: 'Cadastro' },
        { title: 'Registro Retroativo' }
      ]
    }
  }
}